import ActBig from '../../assets/images/chooseGame/Games_posters_nameLess/ActBig-poster.webp';
import AntBattel from '../../assets/images/chooseGame/Games_posters_nameLess/Antbattel-poster.webp';
import BeastBasket from '../../assets/images/chooseGame/Games_posters_nameLess/BeastBasket-poster.webp';
import BehiveLab from '../../assets/images/chooseGame/Games_posters_nameLess/Behaivelab-Poster.webp';
import CanalTour from '../../assets/images/chooseGame/Games_posters_nameLess/CanalTour-poster.webp';
import Deepmarine from '../../assets/images/chooseGame/Games_posters_nameLess/Deepmarine-Poster.webp';
import DinerDash from '../../assets/images/chooseGame/Games_posters_nameLess/DinerDashPoster.webp';
import Freesign from '../../assets/images/chooseGame/Games_posters_nameLess/Freesign-Poster.webp';
import GridTwist from '../../assets/images/chooseGame/Games_posters_nameLess/GridTwist-Poster.webp';
import HexMatch from '../../assets/images/chooseGame/Games_posters_nameLess/HexMatch-poster.webp';
import Jupitario from '../../assets/images/chooseGame/Games_posters_nameLess/Jupitario-Poster.webp';
import KanwaKango from '../../assets/images/chooseGame/Games_posters_nameLess/kangaroo-Kanwa-Poster.webp';
import Lexileague from '../../assets/images/chooseGame/Games_posters_nameLess/laxileague-Poster.webp';
import Loopylizer from '../../assets/images/chooseGame/Games_posters_nameLess/Loopylizer-Poster.webp';
import PaintSplash from '../../assets/images/chooseGame/Games_posters_nameLess/PaintSplash.webp';
import RubiFruit from '../../assets/images/chooseGame/Games_posters_nameLess/RubiFruit-poster.webp';
import SolarizCity from '../../assets/images/chooseGame/Games_posters_nameLess/SolarizCity-poster.webp';
import SpaceBumper from '../../assets/images/chooseGame/Games_posters_nameLess/SpaceBumper.webp';
import SpaceX from '../../assets/images/chooseGame/Games_posters_nameLess/spaceoX-Poster.webp';
import Squirrlo from '../../assets/images/chooseGame/Games_posters_nameLess/Squirrlo-Poster.webp';
import StreetSprint from '../../assets/images/chooseGame/Games_posters_nameLess/StreetSprint-Poster.webp';
import SugarSmash from '../../assets/images/chooseGame/Games_posters_nameLess/SugarSmash-Poster.webp';
import Trainaid from '../../assets/images/chooseGame/Games_posters_nameLess/TrainAid-Poster.webp';

const ExtractGamePoster = (type) =>{
    switch (type) {
        case 0:
          return Squirrlo;
        case 1:
          return Jupitario;
        case 2:
          return Deepmarine;
        case 3:
          return SpaceX;
        case 4:
          return Freesign;
        case 5:
          return KanwaKango;
        case 6:
          return Lexileague;
        case 7:
          return Trainaid;
        case 8:
          return Loopylizer;
        case 9:
          return DinerDash;
        case 10:
          return SugarSmash;
        case 11:
          return StreetSprint;
        case 12:
          return CanalTour;
        case 13:
          return AntBattel;
        case 14:
          return HexMatch;
        case 15:
          return BeastBasket;
        case 16:
          return ActBig;
        case 17:
          return SolarizCity;
        case 18:
          return BehiveLab;
        case 19:
          return RubiFruit;
        case 20:
          return SpaceBumper;
        case 21:
          return GridTwist;
        case 22:
          return PaintSplash;
        default:
          return BeastBasket;
      }
};

export default ExtractGamePoster;
